import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the WidgetResultByDimensionEngagement state domain
 */

const selectWidgetResultByDimensionEngagementDomain = (state) =>
  state.get("widgetResultByDimensionEngagement", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoadingDimensions = () =>
  createSelector(selectWidgetResultByDimensionEngagementDomain, (state) =>
    state.get("isLoadingDimensions")
  )

export const makeSelectDimensionsDrillDown = () =>
  createSelector(selectWidgetResultByDimensionEngagementDomain, (state) =>
    state.get("dimensionsDrillDown")
  )

export const makeSelectDivisions = () =>
  createSelector(selectWidgetResultByDimensionEngagementDomain, (state) =>
    state.get("divisions")
  )

export const makeSelectShowDimensionBenchmark = () =>
  createSelector(selectWidgetResultByDimensionEngagementDomain, (state) =>
    state.get("showDimensionBenchmark")
  )

/**
 * Default selector used by WidgetResultByDimensionEngagement
 */

const makeSelectWidgetResultByDimensionEngagement = () =>
  createSelector(selectWidgetResultByDimensionEngagementDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectWidgetResultByDimensionEngagement
export { selectWidgetResultByDimensionEngagementDomain }
